import get from 'lodash/get';
import playerStatuses from '../utils/playerStatuses';

const NAMESPACE = 'player';

export const selectCanScrub = (state) => get(state, [NAMESPACE, 'canScrub']);
export const selectExternalHtmlPlayerUrl = (state) =>
  get(state, [NAMESPACE, 'externalHtmlPlayerUrl']);
export const selectIsTunePrimed = (state) =>
  get(state, [NAMESPACE, 'isTunePrimed']);
export const selectPlayerStatus = (state) =>
  get(state, [NAMESPACE, 'playerStatus']);
export const selectIsIdle = (state) =>
  selectPlayerStatus(state) === playerStatuses.idle;
export const selectIsPlaying = (state) =>
  selectPlayerStatus(state) === playerStatuses.playing;
export const selectNowPlaying = (state) =>
  get(state, [NAMESPACE, 'nowPlaying']);
export const selectNowPlayingUpsell = (state) =>
  get(state, [NAMESPACE, 'nowPlaying', 'upsell'], {});
export const selectNowPlayingCanShowAds = (state, fallback) =>
  get(state, [NAMESPACE, 'nowPlaying', 'ads', 'canShowAds'], fallback);
export const selectCanChangePlaybackRate = (state) =>
  get(state, [NAMESPACE, 'canChangePlaybackRate'], false);
export const selectCurrentlyPlayingGuideId = (state) =>
  get(state, [NAMESPACE, 'tunedGuideId'], '');
export const selectAutoPlayReady = (state) =>
  get(state, [NAMESPACE, 'autoPlayReady']);
export const selectAutoPlayGuideItem = (state) =>
  get(state, [NAMESPACE, 'autoPlayGuideItem']);
